<template>
	<div class="chat-cluster-list">
		<div class="chat-cluster-search">
			<div class="chat-cluster-search-input">
				<input type="text" placeholder="请输入群名称" v-model="keyword">
				<span class="chat-cluster-search-icon"></span>
			</div>
			<div class="chat-cluster-search-filter" @click="customFilterClick" title="客服过滤">
			</div>
			<div class="chat-cluster-add" @click="createCluster" title="创建新群">
			</div>
		</div>
		<div class="chat-cluster-items">
			<div class="chat-cluster-items-wrap" @scroll="clusterScroll" id="chat-cluster-items-wrap">
				<div class="chat-cluster-item" v-for="cluster in clusterList"
				 @click="clusterClick(cluster)" 
				 :class="{'chat-cluster-item-active': cluster.id == currentCluster.id}" 
				 :key="'chat-cluster-list-'+cluster.id">
					<div class="chat-cluster-avater">
						<img :src="cluster.cluster_photo | connectHost" alt="">
					</div>
					<div class="chat-cluster-name">
						{{cluster.cluster_name}}
					</div>
				</div>
				<div class="chat-fans-refresh" v-if="!canRefresh">
					<img src="/img/loading.gif" alt="" v-if="!isEnd">
					<span v-if="!isEnd">数据加载中...</span>
					<span v-if="isEnd">{{clusterList.length}}条记录</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {getListByCustomWxId} from '../../../network/local/cluster.js'
	
	export default {
		name: "ChatClusterList",
		props:{
			currentCustom:{
				type: Object,
				default:function(){
					return {
						id: 0,
						open_id: ''
					}
				}
			}
		},
		data(){
			return {
				lastId: 0,
				canRefresh: false,
				isEnd:false,
				filterOpen: false,
				currentCluster:{
					id: 0,
					name: '',
					avatar: ''
				},
				clusterList: [],
				keyword: ''
			}
		},
		methods:{
			// 初始数据
			init(){
				this.canRefresh = false
				this.isEnd = false
				this.lastId = 0
				this.clusterList = []
			},
			
			// 客服过滤点击
			customFilterClick(){
				this.filterOpen = !this.filterOpen
				this.$emit('custom-filter',this.filterOpen)
			},
			
			// 群点击
			clusterClick(value){
				this.currentCluster = value
				this.$emit('cluster-click',value)
			},
			
			// 滚动刷新数据
			clusterScroll(event){
				let page = document.getElementById("chat-cluster-items-wrap")
				if(page.scrollTop+page.clientHeight >= page.scrollHeight-25 && this.canRefresh){
					this.canRefresh = false
					this.showData()
				}
			},
			
			// 获取数据，并渲染列表
			showData(){
			  let param = {
				keyword: this.keyword
			  }
			  getListByCustomWxId(this.currentCustom.open_id,this.lastId,param,(data)=>{
					let len = data.length
					if(len > 0){
						for(let i = 0;i<len;i++){
							this.clusterList.push(data[i])
						}
						this.lastId = data[len - 1].id
						this.canRefresh = true
					}else{
						this.canRefresh = false
						this.isEnd = true
					}
			  })
			},
			
			// 拉群按钮点击
			createCluster(){
				this.$emit('create-cluster-call')
			},
			
			// 创建群后渲染列表
			createRoom(data){
				if(data.cluster_id === undefined){
					return
				}
				let item = {
					id: data.cluster_id,
					cluster_name: data.cluster_name,
					cluster_photo: data.cluster_photo,
					wechat_cluster_id: data.wechat_cluster_id,
					custom_id:data.with_account_id,
					custom_name: data.account_name,
					custom_open_id: data.with_account_open_id,
					owner_id:data.with_account_id
				}
				this.clusterList.unshift(item)
			},	
			
			// 删除群-只是页面渲染
			deleteRoom(id){
				if(id !== undefined && id > 0 && this.clusterList.length > 0){
					for (let i = 0; i < this.clusterList.length; i++) {
						if(this.clusterList[i].id == id){
							this.clusterList.splice(i,1)
							break
						}
					}
				}
				this.$emit('cluster-delete-call',id)
			},
			
			// 更新群昵称
			updateList(id,name){
				if(id !== undefined && id > 0 && this.clusterList.length > 0){
					for (let i = 0; i < this.clusterList.length; i++) {
						if(this.clusterList[i].id == id){
							this.clusterList[i].cluster_name = name
							break
						}
					}
				}
			}
		},
		
		computed:{
			otherEvent(){
				return this.$store.state.otherEvent
			}
		},
		
		watch:{
			currentCustom(nVal){
				this.init()
				this.showData()
			},
			
			// 监听socket事件
			otherEvent(nVal){
				if(nVal.type === undefined){
					return
				}
				switch(nVal.type){
					case 'create_cluster':
						this.createRoom(nVal)
						break
					case 'C_ExitChatRoom':
						this.deleteRoom(nVal.clusterId)
						break
					case 'AT_update_cluster_name':
						this.updateList(nVal.clusterId,nVal.clusterName)
						break
				}
			},
			
			// 监听搜索词变化
			keyword(){
				this.init()
				this.showData()
			}
		},
		
		mounted() {
			this.showData()
		}
	}
</script>

<style>
	.chat-cluster-list{
		position: relative;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	.chat-cluster-list .chat-cluster-search{
		width: 100%;
		padding: 0 20px;
		height: 50px;
		overflow: hidden;
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
	}
	.chat-cluster-search .chat-cluster-search-input{
		width: 0;
		height: 30px;
		position: relative;
		flex-grow: 1;
		margin-right: 8px;
	}
	.chat-cluster-search .chat-cluster-search-input input{
		display: block;
		height: 30px;
		line-height: 30px;
		width: 100%;
		border: 1px solid #CFCFCF;
		border-radius: 4px;
		padding: 0 10px 0 30px;
		box-sizing: border-box;
		font-size: 12px;
	}
	.chat-cluster-search .chat-cluster-search-input input:focus{
		outline: none;
		border: 1px solid #42B983;
	}
	.chat-cluster-search-input .chat-cluster-search-icon{
		width: 30px;
		height: 32px;
		position: absolute;
		top: 0;
		left: 0;
		background-image: url(../../../assets/img/c-all-search.png);
		background-size: 18px auto;
		background-repeat: no-repeat;
		background-position: center;	
	}
	.chat-cluster-search .chat-cluster-search-filter,.chat-cluster-search .chat-cluster-add{
		width: 26px;
		height: 26px;
		background-size: 14px auto;
		background-repeat: no-repeat;
		background-position: center;	
		border: 1px solid #b1b1b1;
		border-radius: 15px;
		cursor: pointer;
	}
	.chat-cluster-search .chat-cluster-search-filter{
		background-image: url(../../../assets/img/c-all-filter.png);
	}
	.chat-cluster-search .chat-cluster-add{
		background-image: url(../../../assets/img/c-all-add.png);
		margin-left: 8px;
	}
	.chat-cluster-list .chat-cluster-items{
		position: absolute;
		top: 50px;
		left: 0;
		bottom: 0;
		right: 0;
		overflow: hidden;
	}
	.chat-cluster-items .chat-cluster-items-wrap{
		position: relative;
		width: 100%;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.chat-cluster-items-wrap::-webkit-scrollbar{
		width: 6px;
		height: auto;
	}
	.chat-cluster-items-wrap::-webkit-scrollbar-track{
	  border-radius: 3px;
	  background:#e3e3e3;
	}
	.chat-cluster-items-wrap::-webkit-scrollbar-thumb{
		border-radius: 3px;
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
		background:#cbcbcb;
		cursor: pointer;
	}
	.chat-cluster-items-wrap .chat-cluster-item{
		height: 60px;
		padding: 10px 20px;
		width: 100%;
		box-sizing: border-box;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		cursor: pointer;
	}
	.chat-cluster-items-wrap .chat-cluster-item-active{
		background-color: #dedede;
	}
	.chat-cluster-item .chat-cluster-avater{
		width: 40px;
		height: 40px;
		overflow: hidden;
		margin-right: 10px;
	}
	.chat-cluster-avater img{
		width: 100%;
		height: 100%;
		border-radius: 4px;
	}
	.chat-cluster-item .chat-cluster-name{
		height: 40px;
		line-height: 40px;
		width: 0;
		flex-grow: 1;
		overflow: hidden;
	}
</style>
